(() => {
  const init = (root) => {
    if (!root || root.dataset.lightboxReady) return;
    root.dataset.lightboxReady = 'true';
    const dialog = root.querySelector('[data-lightbox-dialog]');
    const target = root.querySelector('[data-lightbox-target]');
    const close = root.querySelector('[data-lightbox-close]');
    if (!dialog || !target || !close) return;
    root.querySelectorAll('[data-lightbox-image]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        target.src = trigger.dataset.lightboxImage;
        target.alt = trigger.dataset.lightboxAlt || '';
        dialog.showModal();
      });
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  };
  const boot = () => document.querySelectorAll('[data-lyma-inside-lookers]').forEach(init);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-lyma-inside-lookers]')));
})();
